import { TabsPosition } from 'antd/lib/tabs';
import { Tabs as OriginTabs } from './Tabs';
import { TabPane } from './TabPane';

export type TabsProps = typeof OriginTabs & {
  TabPane: typeof TabPane;
};

const Tabs = OriginTabs as TabsProps;

Tabs.TabPane = TabPane;

export { Tabs };
export type { TabsPosition };
